import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["mobileNav", "menuOpenIcon", "menuCloseIcon"]

  connect() {
    this.showMenu(false)
  }

  toggleMenu() {
    this.showMenu(!this.menuOpen)
  }

  closeMenu() {
    this.showMenu(false)
  }

  handleSubmit(event) {
    event.preventDefault()

    if (window.appAlert) {
      window.appAlert.success("Em breve entraremos em contato com seu roteiro personalizado.", "Recebemos seu pedido")
      return
    }

    alert("Obrigada! Em breve entraremos em contato com seu roteiro personalizado.")
  }

  showMenu(open) {
    this.menuOpen = open
    if (this.hasMobileNavTarget) {
      this.mobileNavTarget.classList.toggle("hidden", !open)
    }
    if (this.hasMenuOpenIconTarget) {
      this.menuOpenIconTarget.classList.toggle("hidden", open)
    }
    if (this.hasMenuCloseIconTarget) {
      this.menuCloseIconTarget.classList.toggle("hidden", !open)
    }
  }
}
